// import React from 'react'
// import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'
// import { ChartsWidget9C1 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget9C1'
// interface BeneficiaryData {
//     image: string
//     name: string
//     count: number
// }

// interface CouponAnalyticsProps {
//     schemeCount?: number
//     couponCreated?: number
//     couponIssued?: number
//     couponRedeemed?: number
//     pieChartData?: Array<{ name: string; value: number }>
//     issuedValue?: number | string
//     redeemValue?: number | string
//     topBeneficiaries?: BeneficiaryData[]
// }

// const CouponAnalyticsDashboard: React.FC<CouponAnalyticsProps> = ({
//     schemeCount = 12,
//     couponCreated = 45,
//     couponIssued = 38,
//     couponRedeemed = 28,
//     pieChartData = [
//         { name: 'Issued', value: 38 },
//         { name: 'Redeemed', value: 28 },
//         { name: 'Pending', value: 10 },
//     ],
//     issuedValue = '24,500',
//     redeemValue = '18,200',
//     // topBeneficiaries = [
//     //     { image: 'https://via.placeholder.com/40', name: 'John Doe', count: 12 },
//     //     { image: 'https://via.placeholder.com/40', name: 'Jane Smith', count: 9 },
//     //     { image: 'https://via.placeholder.com/40', name: 'Mike Johnson', count: 7 },
//     // ],
// }) => {
//     const COLORS = ['#7239ea', '#ffc700', '#e0e0e0']


//     const topBeneficiaries = [
//         {
//             image: 'https://i.pravatar.cc/150?img=1',
//             name: 'John Doe',
//             count: 12
//         },
//         {
//             image: 'https://i.pravatar.cc/150?img=2',
//             name: 'Jane Smith',
//             count: 9
//         },
//         {
//             image: 'https://i.pravatar.cc/150?img=3',
//             name: 'Mike Johnson',
//             count: 7
//         },
//     ]

//     const cardStyle = {
//         flex: 1,
//         backgroundColor: '#ffffff',
//         border: '1px solid #e0e0e0',
//         borderRadius: '8px',
//         padding: '16px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         height: '75px',
//         boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//     } as const

//     return (
//         <div style={{ padding: '24px', backgroundColor: 'white', minHeight: '50vh' }}>


//             {/* Header */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
//                 <div>
//                     {/* <h1 style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a', margin: 0, marginBottom: '8px' }}>
//                         Coupon Analytics
//                     </h1>
//                     <p style={{ fontSize: '14px', color: '#666', margin: 0 }}>
//                         Track your coupon performance and beneficiary engagement
//                     </p> */}
//                 </div>

//                 <select style={{
//                     padding: '8px 16px',
//                     borderRadius: '8px',
//                     border: '1px solid #e0e0e0',
//                     backgroundColor: '#ffffff',
//                     fontSize: '14px',
//                     fontWeight: '500',
//                     color: '#333',
//                     cursor: 'pointer',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
//                 }}>
//                     <option value='lifetime'>Lifetime</option>
//                     <option value='thisYear'>This year</option>
//                 </select>
//             </div>


//             {/* First Row - Stat Cards */}
//             <div style={{ display: 'flex', gap: '16px', marginBottom: '32px' }}>
//                 <div style={{ ...cardStyle }}>
//                     <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Scheme launched</div>
//                     <div style={{ fontSize: '24px', fontWeight: '700', color: '#7239ea' }}>
//                         {schemeCount}
//                     </div>
//                 </div>
//                 <div style={{ ...cardStyle }}>
//                     <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon created</div>
//                     <div style={{ fontSize: '24px', fontWeight: '700', color: '#ffc700' }}>
//                         {couponCreated}
//                     </div>
//                 </div>
//                 <div style={{ ...cardStyle }}>
//                     <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon issued</div>
//                     <div style={{ fontSize: '24px', fontWeight: '700', color: '#3e97ff' }}>
//                         {couponIssued}
//                     </div>
//                 </div>
//                 <div style={{ ...cardStyle }}>
//                     <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon redeemed</div>
//                     <div style={{ fontSize: '24px', fontWeight: '700', color: '#1dd1a1' }}>
//                         {couponRedeemed}
//                     </div>
//                 </div>
//             </div>

//             {/* Second Row - Pie Chart + Values + Table */}
//             <div style={{ display: 'flex', gap: '20px' }}>
//                 {/* Pie Chart Section */}
//                 <div style={{ flex: 0.9, minWidth: '280px' }}>
//                     <ChartsWidget9C1
//                         className="mb-5"
//                         label="Beneficiary"
//                         data={[
//                             { name: 'Plastic', value: 1200 },
//                             { name: 'Paper', value: 800 },
//                             { name: 'Glass', value: 600 },
//                             { name: 'Metal', value: 450 },
//                             { name: 'Other', value: 350 }
//                         ]}
//                     />
//                 </div>
//                 {/* Value Cards */}
//                 <div style={{ flex: 0.6, minWidth: '220px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                     <div style={{ ...cardStyle }}>
//                         <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Issued value</div>
//                         <div style={{ fontSize: '24px', fontWeight: '700', color: '#7239ea' }}>
//                             {issuedValue}
//                         </div>
//                     </div>

//                     <div style={{ ...cardStyle }}>
//                         <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Redeemed value</div>
//                         <div style={{ fontSize: '24px', fontWeight: '700', color: '#1dd1a1' }}>
//                             {redeemValue}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Top Beneficiaries Table */}
//                 <div style={{ ...cardStyle, flex: 1.1, minWidth: '280px', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', height: 'auto' }}>
//                     <p style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 8px 0' }}>
//                         Top 3 beneficiaries
//                     </p>
//                     <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
//                         {topBeneficiaries.map((beneficiary, index) => (
//                             <div
//                                 key={index}
//                                 style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between',
//                                     padding: '12px',
//                                     backgroundColor: '#f8f9fa',
//                                     borderRadius: '8px',
//                                     border: '1px solid #e0e0e0',
//                                     transition: 'all 0.2s ease',
//                                 }}
//                             >
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
//                                     <img
//                                         src={beneficiary.image}
//                                         alt={beneficiary.name}
//                                         style={{
//                                             width: '36px',
//                                             height: '36px',
//                                             borderRadius: '50%',
//                                             border: '2px solid #e0e0e0',
//                                         }}
//                                     />
//                                     <div>
//                                         <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a' }}>
//                                             {beneficiary.name}
//                                         </div>
//                                         <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
//                                             User #{index + 1}
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div
//                                     style={{
//                                         backgroundColor: '#7239ea',
//                                         color: '#fff',
//                                         borderRadius: '20px',
//                                         padding: '4px 12px',
//                                         fontSize: '12px',
//                                         fontWeight: '600',
//                                     }}
//                                 >
//                                     {beneficiary.count} used
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>



//             </div>
//         </div>
//     )
// }

// export default CouponAnalyticsDashboard



import React from 'react'
import { ChartsWidget9C1 } from '../../../../../../_metronic/partials/widgets/charts/ChartsWidget9C1'

interface BeneficiaryData {
    count: number
    userId: string
    username: string
    profilePic: Array<{
        docType: string
        docUrl: string
        docNumber: string | null
    }>
}

interface VoucherAnalyticsResponse {
    uniqueVouchersCreatedLifetime?: number
    vouchersCreatedCountLifetime?: number
    vouchersIssuedCountLifetime?: number
    vouchersRedeemedCountLifetime?: number
    totalValueIssuedLifetime?: number
    totalValueRedeemedLifetime?: number
    breakupByUserType?: Array<{ beneficiaryUserType: string; count: number }>
    breakupByVoucherType?: Array<{ couponType: string; count: number }>
    topReceiversLifetimeByUserType?: BeneficiaryData[]
}

interface CouponAnalyticsProps {
    analyticsData?: VoucherAnalyticsResponse
}

const CouponAnalyticsDashboard: React.FC<CouponAnalyticsProps> = ({
    analyticsData = {}
}) => {
    // Extract data with defaults
    const schemeCount = analyticsData.uniqueVouchersCreatedLifetime || 0
    const couponCreated = analyticsData.vouchersCreatedCountLifetime || 0
    const couponIssued = analyticsData.vouchersIssuedCountLifetime || 0
    const couponRedeemed = analyticsData.vouchersRedeemedCountLifetime || 0
    const issuedValue = analyticsData.totalValueIssuedLifetime || 0
    const redeemValue = analyticsData.totalValueRedeemedLifetime || 0

    // Transform breakupByUserType for pie chart
    const userTypeData = (analyticsData.breakupByUserType || []).map(item => ({
        name: item.beneficiaryUserType,
        value: item.count
    }))

    // Transform breakupByVoucherType for pie chart
    const voucherTypeData = (analyticsData.breakupByVoucherType || []).map(item => ({
        name: item.couponType,
        value: item.count
    }))

    // Get top beneficiaries
    const topBeneficiaries = (analyticsData.topReceiversLifetimeByUserType || []).slice(0, 3)

    // Get profile image URL
    const getProfileImage = (profilePic: BeneficiaryData['profilePic']): string => {
        if (profilePic && profilePic.length > 0 && profilePic[0].docUrl) {
            return profilePic[0].docUrl
        }
        return 'https://i.pravatar.cc/150?img=1'
    }

    const cardStyle = {
        flex: 1,
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '75px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    } as const

    return (
        <div style={{ padding: '24px', backgroundColor: 'white', minHeight: '50vh' }}>

            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
                <div></div>

                <select style={{
                    padding: '8px 16px',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    backgroundColor: '#ffffff',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333',
                    cursor: 'pointer',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                }}>
                    <option value='lifetime'>Lifetime</option>
                    <option value='thisYear'>This year</option>
                </select>
            </div>

            {/* First Row - Stat Cards */}
            <div style={{ display: 'flex', gap: '16px', marginBottom: '32px' }}>
                <div style={{ ...cardStyle }}>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Scheme launched</div>
                    <div style={{ fontSize: '24px', fontWeight: '700', }}>
                        {schemeCount}
                    </div>
                </div>
                <div style={{ ...cardStyle }}>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon created</div>
                    <div style={{ fontSize: '24px', fontWeight: '700', }}>
                        {couponCreated}
                    </div>
                </div>
                <div style={{ ...cardStyle }}>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon issued</div>
                    <div style={{ fontSize: '24px', fontWeight: '700', }}>
                        {couponIssued}
                    </div>
                </div>
                <div style={{ ...cardStyle }}>
                    <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Coupon redeemed</div>
                    <div style={{ fontSize: '24px', fontWeight: '700', }}>
                        {couponRedeemed}
                    </div>
                </div>
            </div>

            {/* Second Row - Pie Charts + Values + Table */}
            <div style={{ display: 'flex', gap: '20px' }}>
                {/* User Type Pie Chart */}


                {/* Voucher Type Pie Chart */}
                <div className='card' style={{ flex: 0.9, minWidth: '280px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <ChartsWidget9C1
                        className="mb-5"
                        label="Coupons by type"
                        data={voucherTypeData}
                    />
                </div>

                <div className='card' style={{ flex: 0.9, minWidth: '280px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                    <ChartsWidget9C1
                        className="mb-5"
                        label="Beneficiary by type"
                        data={userTypeData}
                    />
                </div>

                {/* Value Cards */}
                <div style={{ flex: 0.6, minWidth: '220px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div style={{ ...cardStyle }}>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Issued value</div>
                        <div style={{ fontSize: '24px', fontWeight: '700', }}>
                            {issuedValue}
                        </div>
                    </div>

                    <div style={{ ...cardStyle }}>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>Redeemed value</div>
                        <div style={{ fontSize: '24px', fontWeight: '700', }}>
                            {redeemValue}
                        </div>
                    </div>
                </div>

                {/* Top Beneficiaries Table */}
                <div style={{ ...cardStyle, flex: 1.1, minWidth: '280px', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', height: 'auto' }}>
                    <p style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 8px 0' }}>
                        Top 3 beneficiaries
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                        {topBeneficiaries.map((beneficiary, index) => (
                            <div
                                key={beneficiary.userId}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '12px',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <img
                                        src={getProfileImage(beneficiary.profilePic)}
                                        alt={beneficiary.username}
                                        style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            border: '2px solid #e0e0e0',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div>
                                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a' }}>
                                            {beneficiary.username}
                                        </div>
                                        {/* <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
                                            User #{index + 1}
                                        </div> */}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        backgroundColor: '#7239ea',
                                        color: '#fff',
                                        borderRadius: '20px',
                                        padding: '4px 12px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                    }}
                                >
                                    {beneficiary.count} issued
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CouponAnalyticsDashboard